<template>
    <spinner :size="size" line-fg-color="#025542"></spinner>
</template>

<script>
    import Spinner from 'vue-simple-spinner';
    export default {
        name: "loading",
        props: {
            size: {
                type: String,
                default: 'medium'
            }
        },
        components: {
            Spinner
        }
    }
</script>